import { Box } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const Z_INDEX = 999999
export const PageTransitionOverlayInner = ({
    isNavigating,
}: {
    isNavigating: boolean
}) => {
    if (!isNavigating) return null

    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            w="100vw"
            h="100vh"
            zIndex={Z_INDEX}
            cursor="wait"
        />
    )
}

export const PageTransitionOverlay = () => {
    const router = useRouter()
    const [isNavigating, setIsNavigating] = useState(false)

    useEffect(() => {
        const handleStart = (_url: string, { shallow }: { shallow: boolean }) => {
            if (!shallow) setIsNavigating(true)
        }
        const handleComplete = () => {
            setIsNavigating(false)
        }

        router.events.on('routeChangeStart', handleStart)
        router.events.on('routeChangeComplete', handleComplete)
        router.events.on('routeChangeError', handleComplete)

        return () => {
            router.events.off('routeChangeStart', handleStart)
            router.events.off('routeChangeComplete', handleComplete)
            router.events.off('routeChangeError', handleComplete)
        }
    }, [router])

    return <PageTransitionOverlayInner isNavigating={isNavigating} />
}
